export const categories = [
  { slug: 'lianai', name: '恋爱', description: '甜蜜浪漫的恋爱漫画', icon: 'ri-heart-line' },
  { slug: 'xiaoyuan', name: '校园', description: '青春校园题材漫画', icon: 'ri-building-line' },
  { slug: 'qingchun', name: '青春', description: '热血青春成长漫画', icon: 'ri-sun-line' },
  { slug: 'qihuan', name: '奇幻', description: '奇幻冒险题材漫画', icon: 'ri-magic-line' },
  { slug: 'xuanyi', name: '悬疑', description: '烧脑推理悬疑漫画', icon: 'ri-search-eye-line' },
  { slug: 'guzhuang', name: '古装', description: '古风唯美题材漫画', icon: 'ri-ancient-gate-line' },
  { slug: 'dushi', name: '都市', description: '现代都市生活漫画', icon: 'ri-building-2-line' },
  { slug: 'gaoxiao', name: '搞笑', description: '轻松搞笑日常漫画', icon: 'ri-emotion-laugh-line' },
]